<template>
  <div class="card-base htl-root" id="hp-open-tickets">
    <div class="htl-inner">
      <h4 class="card-title mb-2 text-ellipsis">{{ $t("homePage.cardOne") }}</h4>
      <div class="htl-orders overflow-y-auto pr-2">
        <template v-if="loading">
          <InlineError v-if="hasError" class="state-center" :message="$t('homePage.ticketsError')" />
          <div v-else-if="tickets.length > 0" class="flex flex-col gap-2 mt-2 mb-2">
            <div
              v-for="(ticket, key) in tickets"
              :key="ticket.ticketNumber || key"
              class="htl-item flex justify-between items-center gap-3"
            >
              <!-- sinistra: titolo + dettagli -->
              <div class="flex-1 min-w-0">
                <div class="text-navy font-bold text-ellipsis">{{ getTitle(ticket) }}</div>
                <div class="text-xs text-gray mt-1">#{{ ticket.ticketNumber }} · {{ formatDate(ticket.createdTime) }}</div>
              </div>
              <!-- destra: stato allineato al pulsante, come in HomeDocumentList -->
              <div class="flex items-center gap-3 flex-shrink-0">
                <TicketStatus :status="ticket.statusType" />
                <router-link
                  class="btn-download"
                  :to="getDetailLink(ticket)"
                  :aria-label="$t('tickets.details')"
                >
                  <span class="material-icons" aria-hidden="true">arrow_forward</span>
                </router-link>
              </div>
            </div>
          </div>
          <div v-else class="state-center">
            <i>{{ $t("homePage.noSolutions") }}</i>
          </div>
        </template>
        <div v-else class="state-center">
          <MyLoading :viewLoader="false" type="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import moment from "moment";
import MyLoading from "@/components/MyLoading.vue";
import TicketStatus from "@/components/Feature/Ticket/TicketStatus.vue";
import InlineError from "@/components/Primitives/Feedback/InlineError.vue";

defineProps({
  tickets: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  hasError: { type: Boolean, default: false },
});

const { t } = useI18n();


function formatDate(date) {
  return moment(date).format("DD/MM/YYYY");
}

function getTitle(ticket) {
  return ticket?.cf_short_title || ticket?.subject || ticket?.ticketNumber;
}


function getDetailLink(ticket) {
  const detailSegment = t("nav.detail");
  const service = ticket?.cf_servizi || "";
  const isChangeRequest = service.toLowerCase().includes("change");
  const baseUrl = isChangeRequest
    ? t("nav.reportCrListUrl")
    : t("nav.reportIncidentListUrl");
  return `/${baseUrl}/${detailSegment}/${ticket.ticketNumber}`;
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.htl-root {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: calc(100vh - 290px);
  height: calc(100vh - 290px);
}

.htl-inner {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-rows: auto 1fr;
  gap: 8px;
  padding: 20px 20px 12px 20px;
  overflow: hidden;
}

.htl-orders {
  min-height: 0;
  overflow-y: auto;
  margin-bottom: 10px;
}

.htl-item {
  border: 1px solid $grayFive;
  border-radius: 10px;
  padding: 10px 10px 10px 12px;
}
</style>